import { render, staticRenderFns } from "./tagger.vue?vue&type=template&id=eddc04fa&"
import script from "./tagger.vue?vue&type=script&lang=js&"
export * from "./tagger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports